import React from "react";
import CommonButton from "./CommonButton";
import { CheckCircle, AlertCircle, Info, AlertTriangle } from "lucide-react";

interface Props {
  open: boolean;
  title?: string;
  message: string;
  type?: "success" | "error" | "warning" | "info";
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const iconMap = {
  success: <CheckCircle className="text-green-500 w-8 h-8" />,
  error: <AlertCircle className="text-red-500 w-8 h-8" />,
  warning: <AlertTriangle className="text-yellow-500 w-8 h-8" />,
  info: <Info className="text-blue-500 w-8 h-8" />,
};

const ConfirmAlert: React.FC<Props> = ({
  open,
  title,
  message,
  type = "info",
  confirmText = "OK",
  cancelText = "Cancel",
  showCancel = false,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-2xl p-6 w-[90%] max-w-sm shadow-xl text-center">
        {/* ICON */}
        <div className="flex justify-center mb-3">{iconMap[type]}</div>

        {/* TITLE */}
        {title && <p className="text-lg font-semibold mb-2">{title}</p>}

        {/* MESSAGE */}
        <p className="text-sm text-gray-600 mb-5">{message}</p>

        {/* BUTTONS */}
        <div className="flex gap-2 justify-center">
          {showCancel && (
            <CommonButton
              text={cancelText}
              variant="outline"
              onClick={onCancel}
              textContainerClassName="px-4 py-2"
              rounded="md"
            />
          )}

          <CommonButton
            text={confirmText}
            variant="filled"
            rounded="md"
            onClick={onConfirm}
            className="!w-[70%]"
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmAlert;
